const endpoints = {
    register: `/auth/register`,
    registerInstructors: `/auth/register-instructors`,
    login: `/auth/login`,
    verifyLoginTwoFactor: `/auth/verify-login-2fa`,
    logout: `/auth/logout`,
    verifyEmail: `/auth/verify-email`,
    forgotPassword: `/auth/forgot-password`,
    resetPassword: `/auth/reset-password`,
    mentionUsers: `/auth/send-mention-email`,
    replyEmail: `/auth/send-reply-email`,
    users: `/users`,
    userById: (id) => `/users/${id}`,
    suppliers: '/auth/my-suppliers',
    suppliersBatch: '/auth/my-suppliers-batch',
    surveys: `/auth/my-surveys`,
    surveyTemplateById: (id) => `/survey-templates/${id}`,
    videos: `/videos`,
    videosById: (id) => `/videos/${id}`,
    watchLogs: `/watch-logs`,
    watchLogById: (id) => `/watch-logs/${id}`,
    errorLogs: `/error-logs`,
    errorLogById: (id) => `/error-logs/${id}`,
    upload_file: `videos/upload_file`,
    billOfMaterials: '/auth/my-bill-of-materials',
    billOfMaterialsBatchAdd: '/auth/my-bill-of-materials-batch-add',
    projects: `/projects`,
    projectById: (id) => `/projects/${id}`,
    projectColumnSets: (projectId) => `/projects/${projectId}/column-sets`,
    projectColumnSetById: (projectId, setId) => `/projects/${projectId}/column-sets/${setId}`,
    emailQueueEnqueue: `/email-queue/enqueue`,
    emailQueueActive: `/email-queue/active`,
    emailQueueItem: (id) => `/email-queue/${id}`,
    signatures: '/auth/my-signatures',
    importAssistant: '/auth/import-assistant',
    activityAccounts: '/admin/activity/accounts',
    activitySessions: '/admin/activity/sessions',
    activityEvents: '/admin/activity/events',
    activityEventsExport: '/admin/activity/events/export',
};

export default endpoints;
